import Http from '../http'
// 报表统计模块API
export default {
  // 报警报表---报警汇总报表
  alarmsSummary(params) {
    return Http.post('/alarms/summary.do', params)
  },
  // 导出 报警汇总报表
  exportSummary() {
    return '/alarms/summaryExport.do'
  },
  // 报警报表---报警明细报表
  alarmsDetail(params) {
    return Http.post('/alarms/detail.do', params)
  },
  // 导出 报警明细报表
  exportDetail() {
    return '/alarms/detailExport.do'
  },
  // 停车报表-停车未熄火汇总、超时停车汇总表
  alarmsParkSummary(params) {
    return Http.post('/alarms/summaryPark.do', params)
  },
  // 导出 停车未熄火汇总、超时停车汇总表
  exportParkSummary() {
    return '/alarms/summaryParkExport.do'
  },
  // 停车报表-停车未熄火明细、超时停车明细表
  alarmsParkDetail(params) {
    return Http.post('/alarms/park.do', params)
  },
  // 导出 停车未熄火汇总、超时停车汇总表
  exportParkDetail() {
    return '/alarms/parkExport.do'
  },
  // 电子围栏-围栏报警明细表
  alarmsFenceDetail(params) {
    return Http.post('/alarms/fence.do', params)
  },
  // 电子围栏-围栏报警汇总表
  alarmsFenceSummary(params) {
    return Http.post('/alarms/fenceSummary.do', params)
  },
  // 导出 围栏报警明细表
  exportFenceDetail() {
    return '/alarms/fenceExport.do'
  },
  // 导出 围栏报警汇总表
  exportFenceSummary() {
    return '/alarms/fenceSummaryExport.do'
  },
  // 上下线报表---上线率报表
  alarmsOnProbability(params) {
    return Http.post('/alarms/onProbability.do', params)
  },
  // 导出 围栏报警明细表
  exportOnProbability() {
    return '/alarms/onProbabilityExport.do'
  },
  // 导出 未打表报警
  exportOregistreratLarm() {
    return '/alarms/oregistreratLarmExport.do'
  },
  // 未打表报警
  oregistreratLarm(params) {
    return Http.post('/alarms/oregistreratLarm.do', params)
  },
  // 报警报表---硬件故障专题报表
  firmwareAlarm(params) {
    return Http.post('/firmware/getAlarm.do', params)
  },
  // 导出 硬件故障专题报表
  exportFirmwareAlarm() {
    return '/firmware/getAlarmExport.do'
  },
  // 报警报表---GPS轨迹异常报表
  traceAnalyzeInfo(params) {
    return Http.post('/firmware/getTraceAnalyzeInfo.do', params)
  },
  // 导出 GPS轨迹异常报表
  traceAnalyzeExport() {
    return '/firmware/getTraceAnalyzeExport.do'
  },
  // 报警报表---轨迹分析漂点位置数据
  traceAddrAnalyze(params) {
    return Http.post('/firmware/getTraceAddrAnalyze.do', params)
  },
  // 导出 轨迹分析漂点位置数据
  traceAddrAnalyzeExport() {
    return '/firmware/getTraceAddrAnalyzeExport.do'
  },
  // 报警报表---定位不连续明细
  getPositioningDiscontinuity(params) {
    return Http.post('/firmware/getPositioningDiscontinuity.do', params)
  },
  // 导出 轨迹分析漂点位置数据
  getPositioningDiscontinuityExport() {
    return '/firmware/getPositioningDiscontinuityExport.do'
  },
  // 报警报表---设备实时录像状态
  getDevRealTimeRecordingStatus(params) {
    return Http.post('/firmware/getDevRealTimeRecordingStatus.do', params)
  },
  // 导出 设备实时录像状态
  getDevRealTimeRecordingStatusExport() {
    return '/firmware/getDevRealTimeRecordingStatusExport.do'
  },
  // 异常不在线设备统计
  abnormalStatus(params) {
    return Http.post('/firmware/abnormalStatus.do', params)
  },
  // 导出 异常不在线设备统计
  abnormalStatusExport() {
    return '/firmware/abnormalStatusExport.do'
  },
  // 客流量统计-查询
  passengerDetail(params) {
    return Http.post('/alarm/passengerDetail.do', params)
  },
  // 客流量统计-导出
  exportPassengerDetail() {
    return '/export/passengerDetailOld.do'
  },
  // 油量异常-查询
  exceptionDetail(params) {
    return Http.post('/oil/exceptionDetail.do', params)
  },
  // 油量异常-导出
  exportexceptionDetail() {
    return '/export/exceptionDetail.do'
  },
  // 海外司机刷卡报表-查询
  dirverSwipeCardDetail(params) {
    return Http.post('/oil/exceptionDetail.do', params)
  },
  // 海外司机刷卡报表-导出
  exportDirverSwipeCardDetailDetail() {
    return '/export/exceptionDetail.do'
  },
  // 物流锁-查询
  getLogisticsLockAlarm(params) {
    return Http.post('/logisticsLock/getLogisticsLockAlarm.do', params)
  },
  // 物流锁-导出
  exportLogisticsLockAlarm() {
    return '/export/exportLogisticsLockAlarm.do'
  },
  // 企业未打表统计
  getCompanyNotPlay(params) {
    return Http.post('/statistics/notPlayingCompanyByDay.do', params)
  },
  // 车辆未打表分析
  getVehicleNotPlay(params) {
    return Http.post('/statistics/notPlayingVehicleByDay.do', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/alarm.js